import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { CodeListService} from './code-list.service';
import {CodeListDTO}  from './dto/code-list.dto';
import {CodeListResponseModel,AllCodeListResponseModel} from '@gtpl/shared-models/planning';
import { CodeListRequest } from './dto/code-list.request';
@ApiTags('code-list')
@Controller('code-list')
export class CodeListController {
  constructor(
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    private codeListService: CodeListService
  ){}
  @Post('/createCodeList')
  async createCodeList(@Body() resourceOperationEfficiencyDto:CodeListDTO,isUpdate:boolean=false): Promise<CodeListResponseModel> {
  try {
      return await this.codeListService.createCodeList(resourceOperationEfficiencyDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CodeListResponseModel, error);
      // return error;
    }
  }
  @Post('/updateCodeList')
  async updateCodeList(@Body() codeListDto: CodeListDTO): Promise<CodeListResponseModel> {
    try {
      return await this.codeListService.createCodeList(codeListDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CodeListResponseModel, error);
    }
  }
  @Post('/getAllCodeList')
  async getAllCodeList(@Req() request: Request): Promise<AllCodeListResponseModel> {
      try {
          return await this.codeListService.getAllCodeList();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllCodeListResponseModel, error)
      }
  }

  @Post('/getAllActiveCodeList')
  async getAllActiveCodeList(@Req() request: Request): Promise<AllCodeListResponseModel> {
      try {
          return await this.codeListService.getAllActiveCodeList();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllCodeListResponseModel, error)
      }
  }

    /**
     * Activate Or De-Activate Value Code list
     * @param getSingleCodelist CodeListResponseModel 
     * @returns Value code list
     */
     @Post('/activateOrDeactivateProduct')
     async activateOrDeactivateProduct(@Body() codeListReq: CodeListRequest): Promise<CodeListResponseModel> {
         try {
             return await this.codeListService.activateOrDeactivateProduct(codeListReq);
         } catch (err) {
             return this.applicationExceptionHandler.returnException(CodeListResponseModel, err);
         }
     }
}
